import {assetUrl} from "@/utils/assetUrl";

export async function getAssetVersion(file: string): Promise<string | number | null> {
    try {
        const mUrl = assetUrl('_versions.json');
        const res = await fetch(`${mUrl}?t=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return null;
        const json = await res.json();
        return json?.assets?.[file]?.v ?? null;
    } catch {
        return null;
    }
}